export default __webpack_public_path__ + "static/NeueHaasUnicaProBold-dae752ee3503e20939cc5979da84fa7e.woff2";